// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"ImageElement--next-sr-only--38sY7Qd","imageButton":"ImageElement--imageButton--3Jeug5b","image":"ImageElement--image--3N8AsnE","open":"ImageElement--open--2b7Qv35"};